import * as React from "react";
const SvgPingPong = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M14.75 2.002a7.25 7.25 0 1 1-.773 14.46c-.209-.023-.344.08-.387.171l-2.03 4.354a1.75 1.75 0 0 1-2.325.846l-.907-.423a1.75 1.75 0 0 1-.846-2.325l2.087-4.475c.04-.088.035-.247-.1-.39a7.25 7.25 0 0 1 5.28-12.217Zm5.75 7.25a5.75 5.75 0 0 0-11.494-.254l9.63 4.491A5.735 5.735 0 0 0 20.5 9.252Zm-9.938 3.94c.484.515.708 1.32.366 2.052l-2.087 4.475a.25.25 0 0 0 .121.332l.907.423a.25.25 0 0 0 .332-.121l2.03-4.354c.358-.767 1.17-1.107 1.904-1.03a5.729 5.729 0 0 0 3.045-.505l-7.985-3.723c.248.931.725 1.769 1.367 2.45Z"
      fill="currentColor"
    />
    <path
      d="M4.75 11.502a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Zm-1.25 2.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgPingPong;
